/**
 * Commonly used color pairs for background/foreground
 * basically maps: backgroundColorName => {backgroundColor, color}
 */
export const getColorPairs = (colorTheme) => {
    return {
        primary: {
            ghost: {
                backgroundColor: colorTheme.primary.ghost,
                color: colorTheme.primary.solid
            },
            ghostHover: {
                backgroundColor: colorTheme.primary.ghostHover,
                color: colorTheme.primary.solid
            },
            solid: {
                backgroundColor: colorTheme.primary.solid,
                color: colorTheme.invert1.p100
            },
            solidHover: {
                backgroundColor: colorTheme.primary.solidHover,
                color: colorTheme.invert1.p100
            }
        },
        parent: {
            ghost: {
                backgroundColor: colorTheme.parent.ghost,
                color: colorTheme.primary.solid
            },
            ghostHover: {
                backgroundColor: colorTheme.parent.ghostHover,
                color: colorTheme.primary.solid
            },
            solid: {
                backgroundColor: colorTheme.parent.solid,
                color: colorTheme.invert1.p100
            },
            solidHover: {
                backgroundColor: colorTheme.parent.solidHover,
                color: colorTheme.invert1.p100
            }
        },
        pending: {
            ghost: {
                backgroundColor: colorTheme.pending.ghost,
                color: colorTheme.primary.solid
            },
            ghostHover: {
                backgroundColor: colorTheme.pending.ghostHover,
                color: colorTheme.primary.solid
            },
            solid: {
                backgroundColor: colorTheme.pending.solid,
                color: colorTheme.invert1.p100
            },
            solidHover: {
                backgroundColor: colorTheme.pending.solidHover,
                color: colorTheme.invert1.p100
            }
        },
        success: {
            ghost: {
                backgroundColor: colorTheme.success.ghost,
                color: colorTheme.success.solid
            },
            ghostHover: {
                backgroundColor: colorTheme.success.ghostHover,
                color: colorTheme.success.solid
            },
            solid: {
                backgroundColor: colorTheme.success.solid,
                color: colorTheme.invert1.p100
            },
            solidHover: {
                backgroundColor: colorTheme.success.solidHover,
                color: colorTheme.invert1.p100
            }
        },
        warning: {
            ghost: {
                backgroundColor: colorTheme.warning.ghost,
                color: colorTheme.primary.solid
            },
            ghostHover: {
                backgroundColor: colorTheme.warning.ghostHover,
                color: colorTheme.primary.solid
            },
            solid: {
                backgroundColor: colorTheme.warning.solid,
                color: colorTheme.invert1.p100
            },
            solidHover: {
                backgroundColor: colorTheme.warning.solidHover,
                color: colorTheme.invert1.p100
            }
        },
        negative: {
            ghost: {
                backgroundColor: colorTheme.negative.ghost,
                color: colorTheme.negative.solid
            },
            ghostHover: {
                backgroundColor: colorTheme.negative.ghostHover,
                color: colorTheme.negative.solid
            },
            solid: {
                backgroundColor: colorTheme.negative.solid,
                color: colorTheme.invert1.p100
            },
            solidHover: {
                backgroundColor: colorTheme.negative.solidHover,
                color: colorTheme.invert1.p100
            }
        }
    };
};
export const getColorTheme = (colorScheme, fullColorTheme) => {
    const colorTheme = Object.assign(Object.assign({}, fullColorTheme[colorScheme]), { white: fullColorTheme.constant.white, black: fullColorTheme.constant.black });
    return Object.assign(Object.assign({}, colorTheme), { pairs: getColorPairs(colorTheme) });
};
//# sourceMappingURL=color.js.map